import styled from 'styled-components/macro';
import * as colors from '../../../common/colorConstants';

export const NotesWrapper = styled.div`
  padding: 96px 36px;
  border-bottom: 1px solid ${colors.lightWhite2};
`;
const fontStyled = styled.p`
  font-family: 'Roboto', serif;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
`;

export const NotesText = styled.div`
  height: 100px;
  overflow: auto;
  justify-content: flex-start;
  padding: 10px 10px 0 15px;
  color: ${colors.gulfBlue};
  font-size: 12px;
  border-radius: 7.2px;
  border: 1px solid ${colors.lightGray24};
  transition: border 0.5s;
  color: ${colors.gulfBlue};
`;

export const NotesTitle = styled(fontStyled)`
  font-size: 14px;
  text-align: center;
  color: ${colors.black4};
  margin-bottom: 0;
`;

export const NotesSubTitle = styled(fontStyled)`
  font-size: 11px;
  text-align: center;
  color: ${colors.darkGray1};
  font-weight: 500;
  line-height: 18px;
  padding: 12px 0 24px;
  margin-bottom: 0;
`;

export const NotesSpinnerWrapper = styled.div`
  width: 100%;
`;
